import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { getIsTutorialComp } from '../utils/globalState';
import { useNavigate } from 'react-router-dom';
import ClientDashboard from './dashboard/ClientDashboard';
import PreviewHomepage from './PreviewHomepage';
import styles from './Homepage.module.css';

const Homepage = () => {
    const { accounts } = useMsal();
    const isAuthenticated = accounts.length > 0;
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) return;
        const value = getIsTutorialComp();
        if (value === true) {
            navigate('/welcome');
        }
    }, [isAuthenticated, accounts, navigate]);

    if (!isAuthenticated) {
        return <PreviewHomepage />;
    }

    return (
        <div className={styles.authContainer}>
            <ClientDashboard />
        </div>
    );
};

export default Homepage;
